import { render, staticRenderFns } from "./MedicalRepInfo.vue?vue&type=template&id=c2f05f8e&scoped=true"
import script from "./MedicalRepInfo.vue?vue&type=script&lang=js"
export * from "./MedicalRepInfo.vue?vue&type=script&lang=js"
import style0 from "./MedicalRepInfo.vue?vue&type=style&index=0&id=c2f05f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f05f8e",
  null
  
)

export default component.exports